<template>
	<div class="home-layout">
		<v-app-bar app clipped-left color="primary">
			<v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>
			<span class="title ml-3 mr-5">
				OSBOD Employee Management System&nbsp;
				<span class="font-weight-light"></span>
			</span>
			<div class="flex-grow-1"></div>
			{{ user.firstname }} {{ user.surname }}&nbsp;&nbsp;
			<v-menu left bottom>
				<template v-slot:activator="{ on }">
					<v-btn icon v-on="on">
						<v-icon>mdi-account-circle</v-icon>
					</v-btn>
				</template>

				<v-list>
					<!--
					FUTURE: Wachtwoord wijzigen in profielmenu — uncomment:
					<v-list-item to="/change_password" link>
						<v-list-item-title>Wachtwoord wijzigen</v-list-item-title>
					</v-list-item>
					-->
					<v-list-item to="/" link>
						<v-list-item-title>Logout</v-list-item-title>
					</v-list-item>
				</v-list>
			</v-menu>
			<!-- <v-text-field
        solo-inverted
        flat
        hide-details
        label="Search"
        prepend-inner-icon="mdi-magnify"
			></v-text-field>-->
		</v-app-bar>
		<v-navigation-drawer
			width="320"
			v-model="drawer"
			:mini-variant.sync="mini"
			:clipped="$vuetify.breakpoint.lgAndUp"
			app
			flat
			class="navigation-drawer"
		>
			<div class="drawer-header">
				<v-list-item>
					<v-list-item-title v-if="!mini">
						<v-img :aspect-ratio="16/9" src="../assets/osbod_background_whatsapp.jpg">
						</v-img>
						<p class="font-weight-black"><strong class="light-blue--text">{{user.tbl_sys_role.name}}</strong></p>
					</v-list-item-title>
					<v-btn v-if="!mini" icon @click.stop="mini = !mini">
						<v-icon>mdi-chevron-left</v-icon>
					</v-btn>
					<v-btn v-if="mini" icon @click.stop="mini = !mini">
						<v-icon>mdi-chevron-right</v-icon>
					</v-btn>
				</v-list-item>
			</div>

			<v-divider></v-divider>

			<div class="drawer-menu-container">
				<v-list 
					dense 
					class="menu-list"
				>
				<template v-for="group in filteredMenuItems">
					<v-list-group 
						v-if="group.items && group.items.length > 0"
						:key="group.title" 
						v-model="group.active" 
						:prepend-icon="group.action"
						no-action
						class="menu-group"
					>
						<template v-slot:activator>
							<v-list-item-content class="menu-item-content">
								<v-list-item-title class="menu-item-title">{{ group.title }}</v-list-item-title>
							</v-list-item-content>
						</template>

						<v-list-item v-for="child in group.items" :key="child.title" :to="child.to" link class="menu-item">
							<v-list-item-icon class="menu-item-icon">
								<v-icon>{{ child.icon }}</v-icon>
							</v-list-item-icon>
							<v-list-item-content class="menu-item-content">
								<v-list-item-title class="menu-item-title">{{ child.title }}</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
					</v-list-group>
					<v-list-item v-else-if="group.to" :key="group.title" :to="group.to" link class="menu-item">
						<v-list-item-icon class="menu-item-icon">
							<v-icon>{{ group.icon }}</v-icon>
						</v-list-item-icon>
						<v-list-item-content class="menu-item-content">
							<v-list-item-title class="menu-item-title">{{ group.title }}</v-list-item-title>
						</v-list-item-content>
					</v-list-item>
				</template>
				</v-list>

				<!-- <a href="http://reports.pepms.com:8082/jasperserver/login.html" target="new"><v-list-item>
					<v-list-item-icon><v-icon>mdi-cloud-print-outline</v-icon></v-list-item-icon>
					<v-list-item-title>Printer portal</v-list-item-title>
				</v-list-item></a> -->
				<a
					v-if="showPrinterPortal"
					href="http://rapportage.ministerie-owcs.cw:8082/jasperserver/login.html"
					target="new"
					class="printer-link"
				>
					<v-list-item>
						<v-list-item-icon><v-icon>mdi-cloud-print-outline</v-icon></v-list-item-icon>
						<v-list-item-title>Printer portal</v-list-item-title>
					</v-list-item>
				</a>
			</div>
		</v-navigation-drawer>
		
		<v-content class="main-content">
			<!-- Provides the application the proper gutter -->
			<v-container fluid class="content-container">
				<!-- If using vue-router -->

				<router-view name="content"></router-view>
			</v-container>
		</v-content>

		<v-footer app>
			<div class="flex-grow-1"></div>&copy; ICTC B.V. Version 1.2.0
		</v-footer>
	</div>
</template>

<script>
// import _ from "lodash";
import { isDashboardBlockedRole, effectiveDashboardRoleId, ROLE_COORDINATOR } from "../router/authMeta";

export default {
	name: "navbar",
	data: function() {
		return {
			// school_id: localStorage.getItem("school_id"),
			// schooltype_id: localStorage.getItem("schooltype_id"),
			user: JSON.parse(localStorage.getItem("user")),
			access: localStorage.getItem("access"),
			// schools: [],
			// selected_school: {},
			// items: [],
			systemadmin: [
				{
					action: "mdi-cogs",
					title: "Configuratie",
					active: false,
					items: [
						{
							title: "Opleidingen",
							icon: "mdi-school",
							to: "/schooladmin/study"
						},
						{
							title: "Klassen",
							icon: "mdi-table-large",
							to: "/schooladmin/schoolclass"
						},
						{
							title: "Deelkwalificaties",
							icon: "mdi-table-large",
							to: "/schooladmin/subject"
						},
						{
							title: "Docent Modules",
							icon: "mdi-chair-school",
							to: "/schooladmin/teachersubjectclass"
						},
						{
							title: "Docent Modules Cursus",
							icon: "mdi-chair-school",
							to: "/schooladmin/teachersubjectclasscursus"
						}
					]
				},
				{
					action: "mdi-account-multiple",
					title: "Student Beheer",
					active: false,
					items: [
						{
							title: "Inschrijvingen",
							icon: "mdi-file-check",
							to: "/schooladmin/studentregistrationadmin"
						},
						{
							title: "Her-Inschrijvingen",
							icon: "mdi-file-account",
							to: "/schooladmin/student_class_projection"
						},
						{
							title: "Her-Inschrijvingen coordinator",
							icon: "mdi-file-account",
							to: "/schooladmin/student_class_projection_coordinator"
						},
						{
							title: "Intake Planning",
							icon: "mdi-calendar",
							to: "/schooladmin/studentintake"
						},
						{
							title: "Intake",
							icon: "mdi-file-check",
							to: "/schooladmin/studentregistrationintake"
						},
						{
							title: "Studenten OSBOD",
							icon: "mdi-account-multiple",
							to: "/schooladmin/student"
						},
						{
							title: "Actieve Student",
							icon: "mdi-file-document",
							to: "/schooladmin/student_cohort"
						},
						{
							title: "Studenten Plaatsing",
							icon: "mdi-file-document",
							to: "/schooladmin/student_class"
						},
						{
							title: "Plaatsing Coordinator",
							icon: "mdi-file-check",
							to: "/schooladmin/studentregistrationcoordinator"
						},
						{
							title: "Studenten Inhaallessen",
							icon: "mdi-chair-school",
							to: "/schooladmin/student_overtake_class"
						},
						{
							title: "Audit Studenten Plaatsing",
							icon: "mdi-account-multiple-outline",
							to: "/schooladmin/student_class_audit"
						}
					]
				},
				{
					action: "mdi-account-multiple-outline",
					title: "Student Beheer Cursus",
					active: false,
					items: [
						{
							title: "Inschrijvingen Cursus",
							icon: "mdi-file-check",
							to: "/schooladmin/studentregistrationcursusadmin"
						},
						{
							title: "Studenten Plaatsing Cursus",
							icon: "mdi-file-document",
							to: "/schooladmin/student_class_cursus"
						}
					]
				},
				{
					action: "mdi-account-group",
					title: "Werknemer Beheer",
					active: false,
					items: [
						{
							title: "Werknemers Bankgegevens",
							icon: "mdi-account-group-outline",
							to: "/schooladmin/employee"
						},
						{
							title: "Actieve Werknemers",
							icon: "mdi-file-document",
							to: "/schooladmin/employee_cohort"
						},
						{
							title: "Administratie Werknemers",
							icon: "mdi-account-convert",
							to: "/schooladmin/adminemployeesignup"
						},
						{
							title: "Mutatie Uren",
							icon: "mdi-format-list-checks",
							to: "/schooladmin/mutation"
						}
					]
				},
				{
					action: "mdi-calendar-remove",
					title: "Verzuim",
					active: false,
					items: [
						{
							title: "Verzuim docenten",
							icon: "mdi-file-document",
							to: "/schooladmin/teacher_absent"
						},
						{
							title: "Verzuim N-O-P",
							icon: "mdi-file-document",
							to: "/schooladmin/employee_absent"
						}
					]
				},
				{
					action: "mdi-clock-outline",
					title: "Uren Verantwoording",
					active: false,
					items: [
						{
							title: "Uren verantwoording Coordinatoren",
							icon: "mdi-timetable",
							to: "/schooladmin/employeetimesheet"
						},
						{
							title: "Admin - To-do list",
							icon: "mdi-timetable",
							to: "/schooladmin/admin_task"
						},
						{
							title: "Admin - Uren verantwoording",
							icon: "mdi-timetable",
							to: "/schooladmin/admin_timesheet"
						},
						{
							title: "To-do list - Inhaal",
							icon: "mdi-timetable",
							to: "/schooladmin/admin_task_overtake"
						},
						{
							title: "Uren verantwoording - Inhaal",
							icon: "mdi-timetable",
							to: "/schooladmin/admin_timesheet_overtake"
						},
						{
							title: "Admin NGU - timeback",
							icon: "mdi-file-document",
							to: "/schooladmin/employee_loa_ovt"
						}
					]
				},
				{
					action: "mdi-school",
					title: "Examenbureau",
					active: false,
					items: [
						{
							title: "Toetsen",
							icon: "mdi-chair-school",
							to: "/schooladmin/exam"
						},
						{
							title: "Toetsen Cursus",
							icon: "mdi-chair-school",
							to: "/schooladmin/examcursus"
						}
					]
				},
				{
					action: "mdi-currency-usd",
					title: "Financieel",
					active: false,
					items: [
						{
							title: "Studykosten",
							icon: "mdi-currency-usd",
							to: "/schooladmin/schoolyearstudycost"
						},
						{
							title: "Finance Plaatsing",
							icon: "mdi-chair-school",
							to: "/schooladmin/financestudentplacement"
						},
						{
							title: "Finance Student",
							icon: "mdi-bank",
							to: "/schooladmin/financestudentview"
						}
					]
				},
				{
					action: "mdi-shield-account",
					title: "Portaalbeheer (systeem)",
					active: false,
					items: [
						{
							title: "Portal gebruikers",
							icon: "mdi-account-key",
							to: "/schooladmin/portal_users"
						},
						{
							title: "Schooljaren",
							icon: "mdi-calendar-range",
							to: "/schooladmin/schoolyear"
						}
					]
				}
			],
			schooladmin: [
				{
					action: "mdi-cogs",
					title: "Configuratie",
					active: false,
					items: [
						{
							title: "Opleidingen",
							icon: "mdi-school",
							to: "/schooladmin/study"
						},
						{
							title: "Klassen",
							icon: "mdi-table-large",
							to: "/schooladmin/schoolclass"
						},
						{
							title: "Deelkwalificaties",
							icon: "mdi-table-large",
							to: "/schooladmin/subject"
						},
						{
							title: "Docent Modules",
							icon: "mdi-chair-school",
							to: "/schooladmin/teachersubjectclass"
						}
					]
				},
				{
					action: "mdi-account-multiple",
					title: "Student Beheer",
					active: false,
					items: [
						{
							title: "Inschrijvingen",
							icon: "mdi-file-check",
							to: "/schooladmin/studentregistrationadmin"
						},
						{
							title: "Her-Inschrijvingen",
							icon: "mdi-file-account",
							to: "/schooladmin/student_class_projection"
						},
						{
							title: "Studenten Plaatsing",
							icon: "mdi-file-document",
							to: "/schooladmin/student_class"
						},
						{
							title: "Plaatsing Coordinator",
							icon: "mdi-file-check",
							to: "/schooladmin/studentregistrationcoordinator"
						},
						{
							title: "Studenten Inhaallessen",
							icon: "mdi-chair-school",
							to: "/schooladmin/student_overtake_class"
						},
						{
							title: "Audit Studenten Plaatsing",
							icon: "mdi-account-multiple-outline",
							to: "/schooladmin/student_class_audit"
						},
						{
							title: "Intake",
							icon: "mdi-file-check",
							to: "/schooladmin/studentregistrationintake"
						}
					]
				},
				{
					action: "mdi-account-group",
					title: "Werknemer Beheer",
					active: false,
					items: [
						{
							title: "Actieve Werknemers",
							icon: "mdi-file-document",
							to: "/schooladmin/employee_cohort"
						},
						{
							title: "Administratie Werknemers OSBOD",
							icon: "mdi-account-convert",
							to: "/schooladmin/adminemployeesignup"
						}
					]
				},
				{
					action: "mdi-clock-outline",
					title: "Uren Verantwoording",
					active: false,
					items: [
						{
							title: "To-do list",
							icon: "mdi-timetable",
							to: "/schooladmin/admin_task"
						},
						{
							title: "Uren verantwoording",
							icon: "mdi-timetable",
							to: "/schooladmin/admin_timesheet"
						},
						{
							title: "Admin NGU - timeback",
							icon: "mdi-file-document",
							to: "/schooladmin/employee_loa_ovt"
						}
					]
				},
				{
					action: "mdi-currency-usd",
					title: "Financieel",
					active: false,
					items: [
						{
							title: "Finance Plaatsing",
							icon: "mdi-chair-school",
							to: "/schooladmin/financestudentplacement"
						},
						{
							title: "Finance Student",
							icon: "mdi-bank",
							to: "/schooladmin/financestudentview"
						}
					]
				},
				{
					action: "mdi-clipboard-text",
					title: "Toets Herkansing",
					active: false,
					items: [
						{
							title: "Toetsen",
							icon: "mdi-chair-school",
							to: "/schooladmin/exam"
						}
					]
				}
			],
			coordinator: [
				{
					action: "mdi-clock-outline",
					title: "Uren Verantwoording",
					active: false,
					items: [
						{
							title: "Uren verantwoording",
							icon: "mdi-timetable",
							to: "/schooladmin/employeetimesheet"
						}
					]
				},
				{
					action: "mdi-account-multiple",
					title: "Student Beheer",
					active: false,
					items: [
						{
							title: "Plaatsing Coordinator",
							icon: "mdi-file-check",
							to: "/schooladmin/studentregistrationcoordinator"
						},
						{
							title: "Her-Inschrijvingen coordinator",
							icon: "mdi-file-account",
							to: "/schooladmin/student_class_projection_coordinator"
						},
						{
							title: "Studenten Inhaallessen",
							icon: "mdi-chair-school",
							to: "/schooladmin/student_overtake_class_coordinator"
						}
					]
				},
				{
					action: "mdi-clipboard-text",
					title: "Toets Herkansing",
					active: false,
					items: [
						{
							title: "Toetsen",
							icon: "mdi-chair-school",
							to: "/schooladmin/exam_coordinator"
						}
					]
				}
			],
			
			examenbureau_coordinator: [
				{
					action: "mdi-clock-outline",
					title: "Uren Verantwoording",
					active: false,
					items: [
						{
							title: "Uren verantwoording",
							icon: "mdi-timetable",
							to: "/schooladmin/employeetimesheet"
						}
					]
				},
				{
					action: "mdi-school",
					title: "Examenbureau",
					active: false,
					items: [
						{
							title: "Toetsen",
							icon: "mdi-chair-school",
							to: "/schooladmin/exam"
						}
					]
				}
			],
			intake: [
				{
					action: "mdi-clock-outline",
					title: "Intake",
					active: false,
					items: [
					{
							title: "Intake",
							icon: "mdi-file-check",
							to: "/schooladmin/studentregistrationintake"
						}
					]
				}

				
			],
			beleidsmedewerker: [
				{
					action: "mdi-clock-outline",
					title: "Uren Verantwoording",
					active: false,
					items: [
						{
							title: "Uren verantwoording",
							icon: "mdi-timetable",
							to: "/schooladmin/employeetimesheet"
						}
					]
				}
			],
			examenbureau: [
				{
					action: "mdi-clock-outline",
					title: "Uren Verantwoording",
					active: false,
					items: [
						{
							title: "To-do list",
							icon: "mdi-timetable",
							to: "/schooladmin/admin_task"
						},
						{
							title: "Uren verantwoording",
							icon: "mdi-timetable",
							to: "/schooladmin/admin_timesheet"
						},
						{
							title: "Admin NGU - timeback",
							icon: "mdi-file-document",
							to: "/schooladmin/employee_loa_ovt"
						}
					]
				},
				{
					action: "mdi-school",
					title: "Examenbureau",
					active: false,
					items: [
						{
							title: "Toetsen",
							icon: "mdi-chair-school",
							to: "/schooladmin/exam"
						}
					]
				}
			],
			administratie: [
				{
					action: "mdi-cogs",
					title: "Configuratie",
					active: false,
					items: [
						{
							title: "Opleidingen",
							icon: "mdi-school",
							to: "/schooladmin/study"
						},
						{
							title: "Klassen",
							icon: "mdi-table-large",
							to: "/schooladmin/schoolclass"
						},
						{
							title: "Deelkwalificaties",
							icon: "mdi-table-large",
							to: "/schooladmin/subject"
						},
						{
							title: "Docent Modules",
							icon: "mdi-chair-school",
							to: "/schooladmin/teachersubjectclass"
						}
					]
				},
				{
					action: "mdi-account-multiple",
					title: "Student Beheer",
					active: false,
					items: [
						{
							title: "Inschrijvingen",
							icon: "mdi-file-check",
							to: "/schooladmin/studentregistrationadmin"
						},
						{
							title: "Her-Inschrijvingen",
							icon: "mdi-file-account",
							to: "/schooladmin/student_class_projection"
						},
						{
							title: "Studenten Plaatsing",
							icon: "mdi-file-document",
							to: "/schooladmin/student_class"
						},
						{
							title: "Plaatsing Coordinator",
							icon: "mdi-file-check",
							to: "/schooladmin/studentregistrationcoordinator"
						},
						{
							title: "Studenten Inhaallessen",
							icon: "mdi-chair-school",
							to: "/schooladmin/student_overtake_class"
						},
						{
							title: "Audit Studenten Plaatsing",
							icon: "mdi-account-multiple-outline",
							to: "/schooladmin/student_class_audit"
						},
						{
							title: "Intake",
							icon: "mdi-file-check",
							to: "/schooladmin/studentregistrationintake"
						}
					]
				},
				{
					action: "mdi-account-group",
					title: "Werknemer Beheer",
					active: false,
					items: [
						{
							title: "Werknemers Bankgegevens",
							icon: "mdi-account-group-outline",
							to: "/schooladmin/employee"
						},
						{
							title: "Actieve Werknemers",
							icon: "mdi-file-document",
							to: "/schooladmin/employee_cohort"
						},
						{
							title: "Administratie Werknemers OSBOD",
							icon: "mdi-account-convert",
							to: "/schooladmin/adminemployeesignup"
						},
						{
							title: "Mutatie Uren",
							icon: "mdi-format-list-checks",
							to: "/schooladmin/mutation"
						}
					]
				},
				{
					action: "mdi-clock-outline",
					title: "Uren Verantwoording",
					active: false,
					items: [
						{
							title: "To-do list",
							icon: "mdi-timetable",
							to: "/schooladmin/admin_task_overtake"
						},
						{
							title: "Uren verantwoording",
							icon: "mdi-timetable",
							to: "/schooladmin/admin_timesheet_overtake"
						},
						{
							title: "Admin NGU - timeback",
							icon: "mdi-file-document",
							to: "/schooladmin/employee_loa_ovt"
						}
					]
				},
				{
					action: "mdi-currency-usd",
					title: "Financieel",
					active: false,
					items: [
						{
							title: "Finance Plaatsing",
							icon: "mdi-chair-school",
							to: "/schooladmin/financestudentplacement"
						},
						{
							title: "Finance Student",
							icon: "mdi-bank",
							to: "/schooladmin/financestudentview"
						}
					]
				}
			],
			admin_finance: [
				{
					action: "mdi-cogs",
					title: "Configuratie",
					active: false,
					items: [
						{
							title: "Opleidingen",
							icon: "mdi-school",
							to: "/schooladmin/study"
						},
						{
							title: "Klassen",
							icon: "mdi-table-large",
							to: "/schooladmin/schoolclass"
						},
						{
							title: "Deelkwalificaties",
							icon: "mdi-table-large",
							to: "/schooladmin/subject"
						},
						{
							title: "Docent Modules",
							icon: "mdi-chair-school",
							to: "/schooladmin/teachersubjectclass"
						}
					]
				},
				{
					action: "mdi-account-multiple",
					title: "Student Beheer",
					active: false,
					items: [
						{
							title: "Inschrijvingen",
							icon: "mdi-file-check",
							to: "/schooladmin/studentregistrationadmin"
						},
						{
							title: "Her-Inschrijvingen",
							icon: "mdi-file-account",
							to: "/schooladmin/student_class_projection"
						},
						{
							title: "Studenten Plaatsing",
							icon: "mdi-file-document",
							to: "/schooladmin/student_class"
						},
						{
							title: "Plaatsing Coordinator",
							icon: "mdi-file-check",
							to: "/schooladmin/studentregistrationcoordinator"
						},
						{
							title: "Studenten Inhaallessen",
							icon: "mdi-chair-school",
							to: "/schooladmin/student_overtake_class"
						},
						{
							title: "Audit Studenten Plaatsing",
							icon: "mdi-account-multiple-outline",
							to: "/schooladmin/student_class_audit"
						},
						{
							title: "Intake",
							icon: "mdi-file-check",
							to: "/schooladmin/studentregistrationintake"
						}
					]
				},
				{
					action: "mdi-account-group",
					title: "Werknemer Beheer",
					active: false,
					items: [
						{
							title: "Werknemers Bankgegevens",
							icon: "mdi-account-group-outline",
							to: "/schooladmin/employee"
						},
						{
							title: "Actieve Werknemers",
							icon: "mdi-file-document",
							to: "/schooladmin/employee_cohort"
						},
						{
							title: "Administratie Werknemers OSBOD",
							icon: "mdi-account-convert",
							to: "/schooladmin/adminemployeesignup"
						},
						{
							title: "Mutatie Uren",
							icon: "mdi-format-list-checks",
							to: "/schooladmin/mutation"
						}
					]
				},
				{
					action: "mdi-clock-outline",
					title: "Uren Verantwoording",
					active: false,
					items: [
						{
							title: "To-do list",
							icon: "mdi-timetable",
							to: "/schooladmin/admin_task_overtake"
						},
						{
							title: "Uren verantwoording",
							icon: "mdi-timetable",
							to: "/schooladmin/admin_timesheet_overtake"
						},
						{
							title: "Admin NGU - timeback",
							icon: "mdi-file-document",
							to: "/schooladmin/employee_loa_ovt"
						}
					]
				}
			],
			administratie_ondersteuning: [
				{
					action: "mdi-clock-outline",
					title: "Uren Verantwoording",
					active: false,
					items: [
						{
							title: "To-do list",
							icon: "mdi-timetable",
							to: "/schooladmin/admin_task"
						},
						{
							title: "Uren verantwoording",
							icon: "mdi-timetable",
							to: "/schooladmin/admin_timesheet"
						},
						{
							title: "Admin NGU - timeback",
							icon: "mdi-file-document",
							to: "/schooladmin/employee_loa_ovt"
						}
					]
				}
			],
			administratie_ondersteuning_weigle: [
				{
					action: "mdi-clock-outline",
					title: "Uren Verantwoording",
					active: false,
					items: [
						{
							title: "To-do list",
							icon: "mdi-timetable",
							to: "/schooladmin/admin_task"
						},
						{
							title: "Uren verantwoording",
							icon: "mdi-timetable",
							to: "/schooladmin/admin_timesheet"
						},
						{
							title: "Admin NGU - timeback",
							icon: "mdi-file-document",
							to: "/schooladmin/employee_loa_ovt"
						}
					]
				},
				{
					action: "mdi-account-multiple",
					title: "Student Beheer",
					active: false,
					items: [
						{
							title: "Inschrijvingen",
							icon: "mdi-file-check",
							to: "/schooladmin/studentregistrationadmin"
						},
						{
							title: "Plaatsing Coordinator",
							icon: "mdi-file-check",
							to: "/schooladmin/studentregistrationcoordinator"
						},
						{
							title: "Intake",
							icon: "mdi-file-check",
							to: "/schooladmin/studentregistrationintake"
						},
						{
							title: "Studenten Plaatsing",
							icon: "mdi-file-document",
							to: "/schooladmin/student_class"
						},
						{
							title: "Audit Studenten Plaatsing",
							icon: "mdi-account-multiple-outline",
							to: "/schooladmin/student_class_audit"
						}
					]
				},
				{
					action: "mdi-currency-usd",
					title: "Financieel",
					active: false,
					items: [
						{
							title: "Finance Plaatsing",
							icon: "mdi-chair-school",
							to: "/schooladmin/financestudentplacement"
						},
						{
							title: "Finance Student",
							icon: "mdi-bank",
							to: "/schooladmin/financestudentview"
						}
					]
				}
			],
			inhalenurenverantwoording: [
				{
					action: "mdi-clock-outline",
					title: "Uren Verantwoording",
					active: false,
					items: [
						{
							title: "To-do list",
							icon: "mdi-timetable",
							to: "/schooladmin/admin_task_overtake"
						},
						{
							title: "Uren verantwoording",
							icon: "mdi-timetable",
							to: "/schooladmin/admin_timesheet_overtake"
						}
					]
				}
			],

			mini: false,
			drawer: true
		};
	},

	created() {
		console.log("Navigation bar...");

		console.log(this.user);
		// this.getSchool();

		// this.schools = this.user.tbl_control_user_schools;
		// console.log(this.schools);

		// if (this.schools.length > 0) {
		// 	this.selected_school = this.schools[0];
		// }

		switch (effectiveDashboardRoleId(this.user)) {
			case 1:
				this.items = this.systemadmin;
				break;
			case 3:
				this.items = this.admin_finance;
				break;
			case 2:
				this.items = this.schooladmin;
				break;
			case 4:
				this.items = this.coordinator;
				break;
			case 5:
				this.items = this.beleidsmedewerker;
				break;
			case 6:
				this.items = this.examenbureau;
				break;
			case 7:
				this.items = this.administratie;
				break;
			case 8:
				this.items = this.administratie_ondersteuning;
				break;
			case 9:
				this.items = this.inhalenurenverantwoording;
				break;
			default:
				break;
			case 10:
				this.items = this.administratie_ondersteuning_weigle;
				break;
			case 11:
				this.items = this.examenbureau_coordinator;
				break;
			case 12:
				this.items = this.intake;
				break;
		}

		if (this.access) {
			console.log("Has Access : " + this.access);
		} else {
			this.$router.push({
				path: "/"
			});
		}
	},
	// watch: {
	// 	school_id: function(value) {
	// 		console.log(value);
	// 		this.$store.dispatch("setSchool", value);
	// 		//Search for school type user schools array
	// 		var index = _.findIndex(this.schools, { school_id: value });
	// 		console.log("School index: " + index);
	// 		this.$store.dispatch(
	// 			"setSchoolType",
	// 			this.schools[index].tbl_school.schooltype_id
	// 		);
	// 	},
	// 	selected_school: function(value) {
	// 		console.log(value);
	// 		this.$store.dispatch("setSchool", value.school_id);
	// 		this.$store.dispatch("setSchoolType", value.tbl_school.schooltype_id);
	// 		this.school_id = value.tbl_school.id;
	// 	}
	//  },
	computed: {
		loggedin() {
			return this.$store.getters.getLoggedin;
		},
		showPrinterPortal() {
			return effectiveDashboardRoleId(this.user) !== ROLE_COORDINATOR;
		},
		// Filter out empty groups and groups with no items; Dashboard first when role may access it
		filteredMenuItems() {
			const dashboardGroup = {
				title: "Dashboard",
				action: "mdi-view-dashboard",
				items: [
					{
						title: "Personeel, verzuim & modules",
						to: "/main/dashboard/operations",
						icon: "mdi-calendar-multiselect"
					},
					{
						title: "Inschrijvingen",
						to: "/main/dashboard/registrations",
						icon: "mdi-school-outline"
					},
					{
						title: "Herinschrijving",
						to: "/main/dashboard/herinschrijving",
						icon: "mdi-account-reactivate"
					}
				]
			};
			var rid = effectiveDashboardRoleId(this.user);
			var showDashboard = !isDashboardBlockedRole(rid);

			if (!this.items || !Array.isArray(this.items)) {
				return showDashboard ? [dashboardGroup] : [];
			}
			const filtered = this.items.filter(group => {
				// Keep groups that have items array with length > 0
				if (group.items && Array.isArray(group.items) && group.items.length > 0) {
					return true;
				}
				// Keep single items that have a 'to' property
				if (group.to) {
					return true;
				}
				// Filter out everything else
				return false;
			});
			if (!showDashboard) {
				return filtered;
			}
			return [dashboardGroup, ...filtered];
		}
		// ,
		// school() {
		// 	return this.$store.getters.getSchool;
		// },
		// // user() {
		// //   return this.$store.getters.getUser;
		// // },
		// schooltype() {
		// 	return this.$store.getters.getSchoolType;
		// }
	},
	methods: {
		handleEdit(index, row) {
			console.log(index, row);
		},
		// getSchool() {
		// 	var self = this;

		// 	self.schools = self.user.tbl_control_user_schools;
		// 	console.log("School fetched...");
		// 	console.log(self.schools);
		// },
		clickLogout() {
			this.$store.dispatch("logout");

			this.$router.push({
				path: "/"
			});
		}
	}
};
</script>

<style scoped>
.navigation-drawer {
	display: flex !important;
	flex-direction: column !important;
	height: 100vh !important;
	overflow: hidden !important;
}

.drawer-header {
	flex-shrink: 0 !important;
}

.drawer-menu-container {
	flex: 1 1 auto !important;
	overflow-y: auto !important;
	overflow-x: hidden !important;
	min-height: 0 !important;
}

.menu-list {
	padding-left: 0 !important;
}

.menu-group {
	padding-left: 0 !important;
}

.menu-item {
	padding-left: 16px !important;
	padding-right: 8px !important;
	min-height: 40px !important;
}

.menu-item-icon {
	margin-right: 12px !important;
	margin-left: 0 !important;
	min-width: 32px !important;
}

.menu-item-content {
	padding: 0 !important;
	margin: 0 !important;
	flex: 1 1 auto !important;
	min-width: 0 !important;
}

.menu-item-title {
	font-size: 14px !important;
	white-space: normal !important;
	word-wrap: break-word !important;
	line-height: 1.3 !important;
	padding-right: 8px !important;
	overflow: visible !important;
	text-overflow: clip !important;
}

.printer-link {
	text-decoration: none !important;
	flex-shrink: 0 !important;
}

.main-content {
	min-height: auto !important;
	height: auto !important;
	overflow: visible !important;
	position: relative !important;
	padding-top: 64px !important;
}

.content-container {
	position: relative !important;
	padding-bottom: 20px !important;
	min-height: auto !important;
}
</style>

<style>
/* Global styles for nested list items in groups */
.menu-group .v-list-group__items .v-list-item {
	padding-left: 48px !important;
	padding-right: 8px !important;
}

.menu-group .v-list-group__header {
	padding-left: 16px !important;
	padding-right: 8px !important;
}

.menu-group .v-list-group__header .v-list-item__content {
	padding: 0 !important;
}

.menu-group .v-list-group__items .v-list-item__content {
	padding: 0 !important;
	margin: 0 !important;
}

/* Navigation drawer should remain scrollable (sidebar) - Vuetify handles positioning with app prop */
.v-navigation-drawer {
	overflow: hidden !important;
}

/* v-content should allow natural content flow for native browser scrolling */
.v-content {
	flex: 1 1 auto !important;
	overflow: visible !important;
	position: relative !important;
	min-height: auto !important;
	height: auto !important;
}

.v-content__wrap {
	overflow: visible !important;
	position: relative !important;
	min-height: auto !important;
	height: auto !important;
}

/* Footer should be at bottom of content */
.home-layout .v-footer {
	position: relative !important;
	margin-top: auto !important;
}

/* Responsive adjustments */
@media (max-width: 960px) {
	.navigation-drawer {
		width: 280px !important;
	}
}

@media (max-width: 600px) {
	.navigation-drawer {
		width: 260px !important;
	}
}
</style>